export default "__VITE_ASSET__0f0a5734__"